"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tooltipPlacement = function tooltipPlacement(theme) {
  return {
    tooltipPlacementLeft: {
      marginRight: theme.spacing(2)
    },
    tooltipPlacementRight: {
      marginLeft: theme.spacing(2)
    },
    tooltipPlacementTop: {
      marginBottom: theme.spacing(2)
    },
    tooltipPlacementBottom: {
      marginTop: theme.spacing(2)
    }
  };
}; //We are using withStyles because tooltip element is appended to body so we can't 
// target it with css classes using styled components


var TooltipDefault = (0, _styles.withStyles)(function (theme) {
  return _objectSpread({
    tooltip: {
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(10)
    }
  }, tooltipPlacement(theme));
})(_Tooltip["default"]);
var TooltipLight = (0, _styles.withStyles)(function (theme) {
  return _objectSpread({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.grey[800],
      boxShadow: theme.shadows[3],
      fontSize: theme.typography.pxToRem(10),
      padding: theme.spacing(3)
    }
  }, tooltipPlacement(theme));
})(_Tooltip["default"]);

var Tooltip = function Tooltip(props) {
  return props.variant === "light" ? _react["default"].createElement(TooltipLight, props) : _react["default"].createElement(TooltipDefault, props);
};

Tooltip.defaultProps = {
  variant: 'dark'
};
var _default = Tooltip;
exports["default"] = _default;